import React from 'react';
import {
  Button,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay
} from '@chakra-ui/react';
import CloseModalIcon from '../../../assets/close-modal-icon.svg';
import BotIcon from '../../../assets/bot-icon.svg';
import ModeratorIcon from '../../../assets/moderator-icon.svg';
import CommunityIcon from '../../../assets/community-icon.svg';
import EditIcon from '../../../assets/pencil-white-icon.svg';
import DeleteModalIcon from '../../../assets/delete-modal-icon.svg';

import { MODERATION_OPTIONS, MODERATION_TYPE } from '../../../constants/article.constant';
import { useNavigate } from 'react-router-dom';

function ArticleFlaggedModal(props) {
  const { isOpen, articleId, onClose, primarySource, primaryViolation } = props;

  const navigate = useNavigate();
  const showIcon = () => {
    switch (primarySource) {
      case MODERATION_OPTIONS.AI:
        return BotIcon;
      case MODERATION_OPTIONS.MODERATOR:
        return ModeratorIcon;
      case MODERATION_OPTIONS.USER_REPORTS:
        return CommunityIcon;
      default:
        return null;
    }
  };

  const flaggedBy = () => {
    switch (primarySource) {
      case MODERATION_OPTIONS.AI:
        return 'content safety system';
      case MODERATION_OPTIONS.MODERATOR:
        return 'moderation team';
      case MODERATION_OPTIONS.USER_REPORTS:
        return 'multiple community members';
      default:
        return null;
    }
  };

  const renderPrimaryViolationTextBy = () => {
    switch (primarySource) {
      case MODERATION_OPTIONS.AI:
        return (
          <p>
            for potentially <span className="font-[800]">{MODERATION_TYPE[primaryViolation]}</span>{' '}
            content.
          </p>
        );
      case MODERATION_OPTIONS.MODERATOR:
        return (
          <p>
            for <span className="font-[800]">{MODERATION_TYPE[primaryViolation]}</span> content.
          </p>
        );
      case MODERATION_OPTIONS.USER_REPORTS:
        return (
          <p>
            and marked as containing{' '}
            <span className="font-[800]">{MODERATION_TYPE[primaryViolation]}</span> content.
          </p>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <Modal isOpen={isOpen} isCentered onClose={onClose}>
        <ModalOverlay />
        <ModalContent borderRadius={'12px'} w={'407px'} px={'15px'} py={5} bgColor={'light.200'}>
          <ModalHeader p={0} w={'100%'} m={0} maxWidth={'unset'}>
            <div className="flex w-full items-center justify-between pb-2 border-b border-earth-brown-50">
              <p className="text-xl font-[800]">Article Flagged</p>
              <Image
                className="w-[40px] h-[40px] cursor-pointer"
                src={CloseModalIcon}
                onClick={onClose}
                alt=""
              />
            </div>
          </ModalHeader>
          <ModalBody
            p={0}
            my={6}
            display={'flex'}
            flexDir={'column'}
            align={'center'}
            fontWeight={600}
            gap={6}
          >
            <img src={DeleteModalIcon} alt="" className="mx-auto" />

            <div className="flex flex-col text-center">
              <span>Your article has been flagged by our</span>
              <div className="font-[800] flex gap-1 items-center justify-center">
                {flaggedBy()} <img src={showIcon()} alt="" />
              </div>
              {renderPrimaryViolationTextBy()}
            </div>
            <span>
              It will still be published, but the content will appear blurred with a warning to
              readers.
            </span>
            <span>What would you like to do?</span>
          </ModalBody>
          <ModalFooter p="0" gap={'10px'}>
            <Button
              type="submit"
              w="100%"
              variant={'growth-green-solid'}
              onClick={onClose}
              height={'46px'}
              fontSize={'sm'}
              _focusVisible={{
                boxShadow: 'none'
              }}
            >
              Discard for now
            </Button>
            <Button
              type="submit"
              w="100%"
              variant={'growth-green'}
              rightIcon={<Image src={EditIcon} alt="" />}
              fontSize={'sm'}
              height={'46px'}
              _focusVisible={{
                boxShadow: 'none'
              }}
              onClick={() => navigate(`/article/edit?id=${articleId}&step=4&type=edit`)}
            >
              Edit Article
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default ArticleFlaggedModal;
